export const Buy = '1';
export const Sell = '2';
export const BuyMinus = '3';
export const SellPlus = '4';
export const SellShort = '5';
export const SellShortExempt = '6';
export const Undisclosed = '7';
export const Cross = '8';
export const CrossShort = '9';
export const CrossShortExempt = 'A';
export const AsDefined = 'B';
export const Opposite = 'C';
export const Subscribe = 'D';
export const Redeem = 'E';
export const Lend = 'F';
export const Borrow = 'G';
